import React from 'react';

const Border: React.FC = () => {
  return <div className='border-b border border-secondary'></div>;
};

export default Border;
